import * as React from "react";
import ScrollBar from "react-perfect-scrollbar";
import { ScrollOptions } from "../../constants/ScrollOptions";
import { IdStyles } from "../../less/IdStyles";
export var MenuInfoTable = function (_a) {
    var headers = _a.headers, rows = _a.rows;
    return (React.createElement("div", { className: "info-menu__table " + IdStyles.InfoMenuListContainer },
        React.createElement("div", { className: "info-menu__table-thead" },
            React.createElement("div", { className: "info-menu__table-tr " + IdStyles.TableRow }, headers)),
        React.createElement(ScrollBar, { component: "div", options: ScrollOptions, className: "w100" },
            React.createElement("div", { className: "info-menu__table-tbody " + IdStyles.TextNormal }, rows))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info-menu/MenuInfoTable.tsx
// module id = 950
// module chunks = 3